import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Lock, Sparkles } from 'lucide-react';
import { AmariMark } from './Logo';
import { useStore } from '../state/store';

/** Free or Plus, for this device's signed-in person. */
export const useMembership = () => useStore((s) => s.membership);
export const useIsPlus = () => useStore((s) => s.membership === 'plus');

/** Where the Plus page is, remembering what led there (for the interest count). */
export const plusHref = (from: string) => `/plus?from=${encodeURIComponent(from)}`;

/** A small "with Plus" marker, for numbers and options that are part of Plus. */
export function PlusChip({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-1 rounded-full bg-primary-container text-primary-on-container px-2 py-0.5 text-caption font-semibold ${className}`}>
      <Lock size={11} aria-hidden /> {children}
    </span>
  );
}

/** In place of a Plus section: what it is, and a way to see Plus. */
export function PlusLocked({ title, body, from, action }: { title: string; body: ReactNode; from: string; action?: ReactNode }) {
  return (
    <div className="rounded-[18px] border border-line bg-surface p-4">
      <div className="flex items-start gap-3">
        <AmariMark size={36} />
        <div className="flex-1 min-w-0">
          <p className="text-headline">{title}</p>
          <p className="text-subhead text-fg-muted mt-0.5">{body}</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        {action}
        <Link to={plusHref(from)} className="btn btn-sm btn-tonal"><Sparkles size={16} aria-hidden /> See Amari Plus</Link>
      </div>
    </div>
  );
}
